<template>
  <div id="productList">
    <b-container fluid>
      <b-row>
        <b-col md="12">
          <Content
            :isLoading="isLoading"
            :productList="productList"
            :allBrand="allBrand"
            :allBrandSelected="allBrandSelected"
            :searchInput="searchInput"
            :isFinish="isFinish"
            :baseUrl="productParameter.baseUrl"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Content from "./components/product/search/Content";
export default {
  name: "Search",
  components: {
    Content
  },
  data() {
    return {
      isLoading: true,
      isFinish: false,
      searchInput: "",
      increment: 8,
      productParameter: {
        baseUrl: "",
        p: "",
        c: "",
        t: "",
        sort: 0,
        index: 0,
        items: 0,
        total: 0,
        options: []
      },
      productList: [],
    };
  },
  mounted() {
    if (this.production) {
      let appWrapper = document.getElementById("appWrapper");
      this.productParameter.p = appWrapper.getAttribute("data-productplatformid");
      this.productParameter.baseUrl = appWrapper.getAttribute("data-baseurl");
      this.productParameter.items = parseInt(appWrapper.getAttribute("data-items"));
      this.searchInput = appWrapper.getAttribute("data-search");
      console.log(this.productParameter);
      this.load();
    } else {
      this.searchInput = "鍋子";
      this.productList = [
        {
          title: "永恆真愛 純鈦鍺項鍊",
          price: "1300",
          discount: "1100",
          img: "/assets/img/series-1-product-01.jpg",
          category: "項鍊",
          brand: "TiANN",
          date: "2019-06-15T13:45:30",
          slug: "/123"
        },
        {
          title: "永恆真愛-寬版純鈦鍺手鍊",
          price: "7290",
          discount: "6990",
          img: "/assets/img/series-1-product-02.jpg",
          category: "手環",
          brand: "TiANN",
          date: "2019-04-12T13:45:30",
          slug: "/123"
        },
        {
          title: "珍心真意-白珍珠 純鈦耳環一對",
          price: "1300",
          discount: "1000",
          img: "/assets/img/series-1-product-03.jpg",
          category: "墜飾",
          brand: "TiMISA",
          date: "2019-06-12T13:45:30",
          slug: "/123"
        },
        {
          title: "永恆真愛 純鈦鍺項鍊",
          price: "1300",
          discount: "1100",
          img: "/assets/img/series-1-product-01.jpg",
          category: "項鍊",
          brand: "TiANN",
          date: "2019-06-15T13:45:30",
          slug: "/123"
        },
        {
          title: "永恆真愛-寬版純鈦鍺手鍊",
          price: "7290",
          discount: "6990",
          img: "/assets/img/series-1-product-02.jpg",
          category: "手環",
          brand: "TiANN",
          date: "2019-04-12T13:45:30",
          slug: "/123"
        },
        {
          title: "珍心真意-白珍珠 純鈦耳環一對",
          price: "1300",
          discount: "1000",
          img: "/assets/img/series-1-product-03.jpg",
          category: "墜飾",
          brand: "TiMISA",
          date: "2019-06-12T13:45:30",
          slug: "/123"
        },
        {
          title: "永恆真愛 純鈦鍺項鍊",
          price: "1300",
          discount: "1100",
          img: "/assets/img/series-1-product-01.jpg",
          category: "項鍊",
          brand: "TiANN",
          date: "2019-06-15T13:45:30",
          slug: "/products/123"
        },
        {
          title: "永恆真愛-寬版純鈦鍺手鍊",
          price: "7290",
          discount: "6990",
          img: "/assets/img/series-1-product-02.jpg",
          category: "手環",
          brand: "TiANN",
          date: "2019-04-12T13:45:30",
          slug: "/123"
        },
        {
          title: "珍心真意-白珍珠 純鈦耳環一對",
          price: "1300",
          discount: "1000",
          img: "/assets/img/series-1-product-03.jpg",
          category: "墜飾",
          brand: "TiMISA",
          date: "2019-06-12T13:45:30",
          slug: "/123"
        },
        {
          title: "永恆真愛 純鈦鍺項鍊",
          price: "1300",
          discount: "1100",
          img: "/assets/img/series-1-product-01.jpg",
          category: "項鍊",
          brand: "TiANN",
          date: "2019-06-15T13:45:30",
          slug: "/123"
        },
        {
          title: "永恆真愛-寬版純鈦鍺手鍊",
          price: "7290",
          discount: "6990",
          img: "/assets/img/series-1-product-02.jpg",
          category: "手環",
          brand: "TiANN",
          date: "2019-04-12T13:45:30",
          slug: "/123"
        },
        {
          title: "珍心真意-白珍珠 純鈦耳環一對",
          price: "1300",
          discount: "1000",
          img: "/assets/img/series-1-product-03.jpg",
          category: "墜飾",
          brand: "TiMISA",
          date: "2019-06-12T13:45:30",
          slug: "/123"
        },
        {
          title: "永恆真愛 純鈦鍺項鍊",
          price: "1300",
          discount: "1100",
          img: "/assets/img/series-1-product-01.jpg",
          category: "項鍊",
          brand: "TiANN",
          date: "2019-06-15T13:45:30",
          slug: "/123"
        },
        {
          title: "永恆真愛-寬版純鈦鍺手鍊",
          price: "7290",
          discount: "6990",
          img: "/assets/img/series-1-product-02.jpg",
          category: "手環",
          brand: "TiANN",
          date: "2019-04-12T13:45:30",
          slug: "/123"
        },
        {
          title: "珍心真意-白珍珠 純鈦耳環一對",
          price: "1300",
          discount: "1000",
          img: "/assets/img/series-1-product-03.jpg",
          category: "墜飾",
          brand: "TiMISA",
          date: "2019-06-12T13:45:30",
          slug: "/123"
        },
        {
          title: "永恆真愛 純鈦鍺項鍊",
          price: "1300",
          discount: "1100",
          img: "/assets/img/series-1-product-01.jpg",
          category: "項鍊",
          brand: "TiANN",
          date: "2019-06-15T13:45:30",
          slug: "/123"
        },
        {
          title: "永恆真愛-寬版純鈦鍺手鍊",
          price: "7290",
          discount: "6990",
          img: "/assets/img/series-1-product-02.jpg",
          category: "手環",
          brand: "TiANN",
          date: "2019-04-12T13:45:30",
          slug: "/123"
        }
      ];
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    }
  },
  props: ["production"],
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    getProductSearch: function() {
      var self = this;
      if (!self.isLoading) {
        self.isLoading = true;
      }
      let url = "/api/product/search/";
      url += self.productParameter.p + "/" + self.searchInput + "?index=" + self.productParameter.index + "&items=" + self.productParameter.items;
      fetch(url)
        .then(function(response) {
          return response.json();
        })
        .then(function(result) {
          console.log(result);
          if(result.productList.length == 0){
              self.isFinish = true;
          }else{
            self.productList = result.productList;
            self.productParameter.total = result.total;
            self.productParameter.index = result.productList.length;
          }
          self.isLoading = false;
        })
        .catch(function(error) {
          console.log("error:", error);
        });
    },
    loadMoreProductSearch: function() {
      console.log("load more products");
      var self = this;
      self.isLoading = true;
      let url = "/api/product/search/";
      url += self.productParameter.p + "/" + self.searchInput + "?index=" + self.productParameter.index;
      fetch(url)
        .then(function(response) {
          return response.json();
        })
        .then(function(result) {
          console.log(result);
          if(result.productList.length == 0){
              self.isFinish = true;
          }else{
            self.productParameter.total = result.total;
            if(self.productParameter.items + self.increment >= self.productParameter.total){
              self.isFinish = true;
            }else{
              self.productParameter.index += parseInt(result.productList.length);
            }
            Array.prototype.push.apply(self.productList,result.productList);
          }
          self.isLoading = false;
        })
        .catch(function(error) {
          console.log("error:", error);
        });
    },
    load: function() {
      if (this.production) {
        this.getProductSearch();
      }
    },
    incrementProducts: function() {
      let incrementCount = 9;
      this.productParameter.index += incrementCount;
    },
    updateType: function(_type) {
      let productType = this.productParameter.t;
      if (productType === _type) {
        this.incrementProducts();
      } else {
        this.productParameter.t = _type;
      }
      this.load();
    },
    handleScroll: function() {
      let self = this;
      if(!self.isFinish && !self.isLoading){
        let middleScrollPosition = document.documentElement.scrollTop + (window.innerHeight - (window.innerHeight/10));
        let endOfListPostion = document.getElementById("productList").offsetHeight;
        if(middleScrollPosition >= endOfListPostion){
          self.loadMoreProductSearch();
        }
      }
    }
  }
};
</script>
